<template>
    <div class="ticketlist" v-if="!isMobile || !betsOpen">
        <div class="ticketlist-header">
            <div v-if="!isMobile" class="ticketlist-left" :class="!betsOpen ? 'is-selected' : ''" v-on:click="toggleBetsOpen(!betsOpen)">
                <p>{{$t('TICKETLIST')}}</p>
                <i class="iconset icon-arrowdown"></i>
            </div>
            <div class="ticketlist-right" v-if="totalCount">
                <div class="ticketlist-itemcount" :class="(filterSelected == false) ? 'is-selected' : ''" v-on:click="filterSelected = false; toggleBetsOpen(false);">
                    <i class="icon-listtickets iconset"></i>
                    <div class="ticketslist"><span>{{totalCount.all}}</span></div>
                </div>
                <div class="ticketlist-itemcount" :class="(filterSelected == 'ACTIVE') ? 'is-selected' : ''" v-on:click="filterSelected = 'ACTIVE'; toggleBetsOpen(false);">
                    <i class="icon-pending iconset"></i>
                    <div class="pending"><span>{{totalCount.ACTIVE}}</span></div>
                </div>

                <div class="ticketlist-itemcount" :class="(filterSelected == 'WIN') ? 'is-selected' : ''" v-on:click="filterSelected = 'WIN'; toggleBetsOpen(false);">
                    <i class="icon-win iconset"></i>
                    <div class="win"><span>{{totalCount.WIN}}</span></div>
                </div>

                <div class="ticketlist-itemcount" :class="(filterSelected == 'LOST') ? 'is-selected' : ''" v-on:click="filterSelected = 'LOST'; toggleBetsOpen(false);">
                    <i class="icon-lost iconset"></i>
                    <div class="lost"><span>{{totalCount.LOST}}</span></div>
                </div>

                <div class="ticketlist-itemcount" :class="(filterSelected == 'REFUND') ? 'is-selected' : ''" v-on:click="filterSelected = 'REFUND'; toggleBetsOpen(false);">
                    <i class="icon-refund iconset"></i>
                    <div class="refund"><span>{{totalCount.REFUND}}</span></div>
                </div>

            </div>
        </div>
        <div class="tlist fadeInDown" v-show="!betsOpen">
            <div class="tlist-item" v-for="ticket in tickets" v-bind:key="ticket.code">
                <div class="tlist-content" v-on:click.prevent="getTicketData({ticketCode: ticket.code})">
                    <div class="tlist-item-icon">
                        <i v-if="ticket.status == 'ACTIVE' || ticket.status == 'PREPARED'" class="icon-pending iconset active"></i>
                        <i v-else-if="ticket.status == 'WIN'" class="icon-win iconset win"></i>
                        <i v-else-if="ticket.status == 'LOST'" class="icon-lost iconset lost"></i>
                        <i v-else-if="ticket.status == 'REFUND'" class="icon-refund iconset refund"></i>
                    </div>
                    <div class="tlist-item-date">
                        <span class="ticket-id">{{ticket.code}}</span>
                        <span>{{ticket.meta.global.timestampSystem | formatTicketMatchDate}}</span>
                    </div>
                    <div class="tlist-info">
                    <div class="tlist-item-stake">
                        {{$t('PAYIN')}}: <span>{{ticket.payment.sumTotal | formatNum(2)}} {{$getCurrencyAbbrv(getPaymentCurrency(ticket))}}</span>
                        <template v-if="calculateEurConversion">
                            <template v-if="getPaymentCurrency(ticket) === 'HRK'">
                                {{getEurValue(ticket.payment.sumTotal, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                            </template>
                            <template v-else>
                                {{getEurValue(ticket.payment.sumTotal) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                            </template>
                        </template>
                    </div>
                    <div class="tlist-item-payout">
                        {{$t('PAYOUT')}}: <span>{{getActualFields(ticket).payout.sum | formatNum(2)}} {{$getCurrencyAbbrv(getPayoutCurrency(ticket))}}</span>
                        <template v-if="calculateEurConversion">
                            <template v-if="getPayoutCurrency(ticket) === 'HRK'">
                                {{getEurValue(getActualFields(ticket).payout.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                            </template>
                            <template v-else>
                                {{getEurValue(getActualFields(ticket).payout.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                            </template>
                        </template>
                    </div>
                    </div>
                </div>
            </div>
            <div v-if="tickets.length == 0" class="nobets">
                <span v-if="!filterSelected">{{$t('TICKETLISTEMPTY')}}</span>
                <span v-else>{{$t('NOTICKETSFOUNDFORSELECTEDFILTERS')}}</span>
            </div>
            <div class="tlist-all">
                <a href="#" v-on:click="navigateTo(-1)"><i class="iconset icon-arrowleft"></i></a>
                <a href="#" v-on:click="navigateTo(1)"><i class="iconset icon-arrowright"></i></a>
            </div>
        </div>
    </div>
</template>

<script>

import
{
    mapActions,
    mapGetters,
}
from 'vuex';
import PlayerApi from '@/api/Player';

export default
{
    name: 'TicketList',
    props: ['betsOpen'],
    data()
    {
        return {
            allTicketsShown: false,
            filterSelected: false,
            tickets: [],
            start: 0,
            limit: 5,
            totalCount: null,
            evtSource: null,
        };
    },
    async created()
    {
        this.fetchTickets();

        this.subscribeToTicketChanges();
    },
    methods:
    {
        ...mapActions([
            'getTicketData',
        ]),
        subscribeToTicketChanges(retry = 0)
        {
            const me = this;
            let url = '/player/subscribeToTicketChanges';
            const urlParams = new URLSearchParams(window.location.search);
            const clientId = urlParams.get('clientId');
            if (clientId)
            {
                url += `?requestRealmId=${clientId}`;
            }
            this.evtSource = new EventSource(url, { withCredentials: true });

            const func = () =>
            {
                if (retry < 5)
                {
                    setTimeout(() =>
                    {
                        me.subscribeToTicketChanges(retry + 1);
                        try
                        {
                            this.evtSource.close();
                        }
                        catch (error)
                        {
                            // fall silently
                        }
                    }, 5000);
                }
            };

            const interval = setInterval(() =>
            {
                if (this.evtSource.readyState === 2)
                {
                    clearInterval(interval);
                    func();
                }
            }, 1000);

            this.evtSource.addEventListener('error', () =>
            {
                clearInterval(interval);
                func();
            });

            let timeout = null;
            this.evtSource.onmessage = (msg) =>
            {
                window.emit('betChange', msg);
                if (timeout != null)
                {
                    clearTimeout(timeout);
                }
                timeout = setTimeout(() =>
                {
                    me.fetchTickets();
                }, 500);
            };
        },
        navigateTo(page)
        {
            this.start += this.limit * page;

            if (this.start < 0)
            {
                this.start = 0;
            }

            this.fetchTickets();
        },
        toggleBetsOpen(val)
        {
            const me = this;
            me.$emit('toggleBetsOpen', val);
        },
        async fetchTickets()
        {
            const me = this;

            const params = {
                start: me.start,
                limit: me.limit,
            };

            if (me.filterSelected !== false)
            {
                params.status = me.filterSelected;
            }

            const data = await PlayerApi.getTicketList(params);
            me.tickets = data.data || [];
            me.totalCount = data.totalCount;
        },
        getEurValue(val, reverse = false)
        {
            if (this.calculateEurConversion)
            {
                let eurCoeff = parseFloat(this.globals.publicConfig.hrkEurConversion.eurToHrkConversionRate);

                if (reverse
                && this.globals.publicConfig.hrkEurConversion.eurToHrkConversionRateReverse)
                {
                    eurCoeff = this.globals.publicConfig.hrkEurConversion.eurToHrkConversionRateReverse;
                }

                return parseFloat(val) / eurCoeff;
            }

            return 0;
        },
        getActualFields(ticket)
        {
            if (ticket.payoutStatus === 'PAID'
            && ticket.payout)
            {
                return {
                    win:
                    {
                        sum: ticket.payout.sumWin,
                    },
                    payout:
                    {
                        sum: ticket.payout.sumPayout,
                    },
                    taxOnPayout:
                    {
                        sum: ticket.payout.sumTaxOnPayout,
                    },
                };
            }

            const { status, resolveEstimate, resolve } = ticket;

            let payoutCalc = resolveEstimate.calc;

            if (status === 'WIN'
            || status === 'LOST'
            || status === 'REFUND')
            {
                payoutCalc = resolve.calc;
            }

            return payoutCalc;
        },
        getPaymentCurrency(ticket)
        {
            return ticket.payment.currency;
        },
        getPayoutCurrency(ticket)
        {
            if (ticket.payoutStatus === 'PAID'
            && ticket.payout)
            {
                return ticket.payout.currency;
            }

            return ticket.payment.currency;
        },
    },
    watch:
    {
        filterSelected()
        {
            this.fetchTickets();
        },
        'globals.userId'(oldVal, newVal)
        {
            if (oldVal !== newVal)
            {
                this.fetchTickets();
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'isMobile',
            'globals',
        ]),
        calculateEurConversion()
        {
            return this.globals
                && this.globals.publicConfig
                && this.globals.publicConfig.hrkEurConversion
                && this.globals.publicConfig.hrkEurConversion.enabled;
        },
    },
};
</script>
